/**
 * 連絡先フォーム各項目の最大文字数。
 * DBのVARCHAR 桁数に準拠する。
 * フロント・バリデーションの単一基準として、この定数を参照する。
 */
export const CONTACT_FIELD_MAX_LENGTH = {
  lastName: 100,
  firstName: 100,
  lastNameKana: 200,
  firstNameKana: 200,
  email: 100,
  organization: 100,
  department: 100,
  position: 100,
  mobilePhone: 25,
  telExtension: 25,
  altEmail: 100,
  fax: 25,
  postalCode: 25,
  address1: 100,
  address2: 100,
  city: 100,
  prefecture: 100,
  country: 100,
  site: 200,
  linkedIn: 200,
  facebook: 200,
  twitter: 200,
  skype: 200,
  slack: 200,
  github: 200,
  youtube: 200,
  tiktok: 200,
  spotify: 200,
  discord: 200,
  memo: 200,
  externalPhoneNumber: 30,
  customLabel: 80,
} as const

export type ContactFieldKey = keyof typeof CONTACT_FIELD_MAX_LENGTH

/**
 * バリデーション・エラーメッセージ用の項目表示名。
 * フォーム上のラベルに合わせる。
 */
export const CONTACT_FIELD_LABEL: Record<ContactFieldKey, string> = {
  lastName: '姓',
  firstName: '名',
  lastNameKana: 'ふりがな（姓）',
  firstNameKana: 'ふりがな（名）',
  email: 'Eメール',
  organization: '組織',
  department: '部署',
  position: '役職',
  mobilePhone: '携帯電話',
  telExtension: '内線番号',
  altEmail: 'その他Eメール',
  fax: 'Fax',
  postalCode: '郵便番号',
  address1: '住所1',
  address2: '住所2',
  city: '市区町村',
  prefecture: '都道府県',
  country: '国',
  site: 'Webサイト',
  linkedIn: 'LinkedIn',
  facebook: 'Facebook',
  twitter: 'X(Twitter)',
  skype: 'Skype',
  slack: 'Slack',
  github: 'Github',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  spotify: 'Spotify',
  discord: 'Discord',
  memo: 'メモ',
  externalPhoneNumber: '電話番号',
  customLabel: '電話番号ラベル',
}

/**
 * 文字数を数える。
 * MySQL の utf8mb4 VARCHAR(n) は文字数（コードポイント数）で桁数を数えるため、
 * サロゲートペア（絵文字など）を 1 文字として数えるコードポイント長で判定する。
 * （JavaScript の String.length は UTF-16 単位なので絵文字を 2 と数えてしまう）
 * サロゲートペアを 1 文字に置換してから length を取ることで、コードポイント数を算出する。
 */
export const codePointLength = (value: string | null | undefined): number =>
  (value ?? '').replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '_').length
